import { Auth } from "../../../Views/Auth/Auth";
import { useAuth } from "./useAuth/useAuth";
import { Login } from "../../../Views/Login/Login";
import { ReactElement } from "react";
import { ProtectedRoute } from "../accessControl/ProtectedRoute/ProtectedRoute";
import { handleLogout } from "../Logout/handleLogout/handleLogout";
import { Logout } from "../Logout/Logout";
import { AuthVersioningProps } from "core/hooks/useAuthVersioning";
import { onSsoSetup, updateClientDetails } from "core/javascriptChannels";
import { useNavigate } from "react-router-dom";
import { ClientInfoState } from "shared/core/state/clientInfoState";
import { SsoRedirectState } from "shared/core/state/ssoRedirectState";

const useAuthModules = (): AuthVersioningProps => {
  const auth = useAuth();
  const navigate = useNavigate();
  const isMobile = !!window.flutter_inappwebview;

  return {
    auth: (sso?: boolean) => <Auth auth={auth} sso={sso} />,
    Login: () => <Login auth={auth} redirectToHome={isMobile} />,
    Logout: ({ type }: { type?: "default" | "nav" }) => {
      const logout = handleLogout(auth);

      return <Logout type={type} handleLogout={logout} />;
    },
    protect: (el: ReactElement): ReactElement => (
      <ProtectedRoute auth={auth} handleShouldAuthenticate={isMobile ? auth.signinRedirect : undefined}>
        {el}
      </ProtectedRoute>
    ),
    updateClient: () => {
      if (isMobile) {
        updateClientDetails();
      } else {
        navigate("/login", { state: "change_org" });
      }
    },
    handleSsoSetup: (provider?: string) => {
      if (isMobile) {
        SsoRedirectState.set("true");
        provider && onSsoSetup(provider.toLowerCase());
      } else {
        auth.signinRedirect({ redirect_uri: `${window.location.origin}/auth/sso`, extraQueryParams: { client_code: ClientInfoState.getCode() } });
      }
    },
  };
};

export const AuthModulesV2 = (): AuthVersioningProps => {
  const modules = useAuthModules();

  return modules;
};
